module.exports = __webpack_public_path__ + "113c98972dd2300d3a3af4db1d7194d0.svg";